/**
 * Hauteur de la bannière d'impersonation, et la variable CSS qui la publie.
 *
 * La bannière est en `position: fixed` : sans réserver sa hauteur, elle recouvre la navbar au
 * lieu de la décaler (c'est exactement ce qui a dû être corrigé côté odys, #2632). La bannière
 * publie la variable sur `:root` quand elle s'affiche, et le layout la relit avec un fallback à
 * `0px` — ainsi une page sans impersonation ne réserve rien.
 *
 * ⚠️ Vit dans un module SANS `'use client'`, comme `navbar-offset.ts` : importée par des Server
 * Components, une constante exportée d'un module client est résolue en client-reference (une
 * fonction) et non en valeur, ce qui produit une règle CSS invalide, silencieusement ignorée.
 */

export const IMPERSONATION_BANNER_HEIGHT = '44px';

export const IMPERSONATION_BANNER_HEIGHT_VAR = '--impersonation-banner-height';
